import { SSO_LOGIN_ENABLED_CACHE_KEY, SSO_STATE } from "@/constants";
import type { SsoConfiguration } from "@/features/settings/model/ssoConfigurationSlice";

export function cacheSsoLoginEnabled(enabled: boolean): void {
  if (enabled) {
    sessionStorage.setItem(SSO_LOGIN_ENABLED_CACHE_KEY, "true");
    return;
  }
  sessionStorage.removeItem(SSO_LOGIN_ENABLED_CACHE_KEY);
}

export function readCachedSsoLoginEnabled(): boolean {
  return sessionStorage.getItem(SSO_LOGIN_ENABLED_CACHE_KEY) === "true";
}

export function syncSsoLoginEnabledFromConfigurations(configurations: SsoConfiguration[]): void {
  cacheSsoLoginEnabled(configurations.some((config) => config.state === SSO_STATE.ENABLED));
}
